import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { MerchantService } from 'src/app/services/merchant/merchant.service';
import { ReportService } from 'src/app/services/report/report.service';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

@Component({
  selector: 'app-dashboardv2',
  templateUrl: './dashboardv2.component.html',
  styleUrls: ['./dashboardv2.component.scss']
})
export class Dashboardv2Component implements OnInit, AfterViewInit {

  genReportEvent: EventEmitter<string>;
  genPerformanceReportEvent: EventEmitter<string>;
  dropdownItems: any[] = [];
  selectedDropdownIds: any[] = [];
  isAdmin = false;
  isExporting = false;

  private allMerchantGroups: any[] = [];
  private teamToGroupIds: { [teamName: string]: string[] } = {};

  query = {
    startDate: new Date(),
    endDate: new Date(),
    merchantGroupIds: '',
  };

  constructor(
    private merchantService: MerchantService,
    private reportService: ReportService,
    private userService: UserService,
    private toast: ToastrService
  ) {
    this.genReportEvent = new EventEmitter<string>();
    this.genPerformanceReportEvent = new EventEmitter<string>();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.genReports(), 500);
  }

  ngOnInit(): void {
    this.initRole();
    this.getMerchantGroups();
    this.genReports();
  }

  initRole() {
    var userInfo = this.userService.getLocalUserInfo();
    if (userInfo) {
      var roles = userInfo.roles || [];
      this.isAdmin = userInfo.isAdmin
        || userInfo.isSuperAdmin
        || roles.indexOf('Accountant') > -1;
    }
  }

  getMerchantGroups() {
    this.merchantService.getGrantedMerchantGroups().subscribe(data => {
      this.allMerchantGroups = data;
      this.buildDropdownItems();
    });
  }

  buildDropdownItems() {
    if (this.isAdmin) {
      this.teamToGroupIds = {};
      this.allMerchantGroups.forEach(g => {
        var parts = (g.name || '').split(' - ');
        var teamName = parts.length > 1 ? parts[0].trim() : g.name;
        if (!this.teamToGroupIds[teamName]) {
          this.teamToGroupIds[teamName] = [];
        }
        this.teamToGroupIds[teamName].push(g.id);
      });
      this.dropdownItems = Object.keys(this.teamToGroupIds).map(teamName => ({
        id: teamName,
        name: teamName
      }));
    } else {
      this.dropdownItems = this.allMerchantGroups.map(g => ({ id: g.id, name: g.name }));
    }
  }

  onDropdownChange() {
    if (!this.selectedDropdownIds || this.selectedDropdownIds.length === 0) {
      this.query.merchantGroupIds = '';
      return;
    }
    if (this.isAdmin) {
      var allGroupIds = [];
      this.selectedDropdownIds.forEach(teamName => {
        var ids = this.teamToGroupIds[teamName] || [];
        allGroupIds.push(...ids);
      });
      this.query.merchantGroupIds = allGroupIds as any;
    } else {
      this.query.merchantGroupIds = this.selectedDropdownIds as any;
    }
  }

  genReports() {
    this.genReportEvent.next();
  }

  exportOrders(format: string) {
    this.isExporting = true;
    var exportQuery = {
      startDate: moment(this.query.startDate).format(),
      endDate: moment(this.query.endDate).format(),
      merchantGroupIds: this.query.merchantGroupIds || '',
    };
    var isCsv = format === 'csv';
    var contentType = isCsv
      ? 'text/csv;charset=utf-8'
      : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    this.reportService.exportOrders(exportQuery, format).subscribe(
      (data: ArrayBuffer) => {
        var blob = new Blob([data], { type: contentType });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = 'orders_' + moment().format('YYYY-MM-DD') + '.' + format;
        link.click();
        URL.revokeObjectURL(url);
        this.toast.success(isCsv ? 'Đã tải CSV' : 'Đã tải XLSX');
        this.isExporting = false;
      },
      () => {
        this.toast.error('Có lỗi xảy ra khi tải file');
        this.isExporting = false;
      }
    );
  }

  onGetDataDone($event) {
    this.genPerformanceReportEvent.emit();
  }
}
